import React, { useRef } from 'react';
import { useNavigate } from 'react-router';
import noPastCreationFound from '../../assets/images/no_past_creation_found.svg';
import smartSearchIcon from '../../assets/images/smart_search_icon.png';
import { useDispatch, useSelector } from 'react-redux';
import { setIsVisualizePageVisible } from '../../redux/pastCreateionsSlice';
import { usePastCreation } from '../../services/pastCreationService';

const NoPastCreationFound = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const pastCreation = usePastCreation();
    const { generatedImages } = useSelector((state) => state.createImage);
    const abortControllerRef = useRef(null);

    const handleTryAgainButton = () => {
        let page;
        let searchPrompt;

        if (generatedImages.length === 0) {
            
            dispatch(setIsVisualizePageVisible(true));
        }

        navigate('/generate-image');

        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        const abortController = new AbortController();
        abortControllerRef.current = abortController;

        pastCreation(page, searchPrompt, abortController.signal);
    };

    return (
        <div className="w-full h-full flex flex-col items-center justify-center gap-[24px]">
            <img src={noPastCreationFound} alt="no past creation found" />
            <h2 className="text-[40px] font-helveticaDisp-Bold text_cus_primary leading-[48px] tracking-[-0.02em] font-[700]">
                No past creations found
            </h2>
            <p className="text-[23px] leading-[32px] text-secondary">
                It looks like you haven't created anything yet. Why don't you give it a go?
            </p>
            <button
                onClick={handleTryAgainButton}
                className="w-fit h-[48px] rounded-[8px] flex items-center justify-center gap-[8px] bg-pink-primary hover:bg-pink-dark text-white px-[16px] py-[12px]"
            >
                <img src={smartSearchIcon} alt="" />
                <span className="leading-[24px] tracking-[-0.02em] font-helveticaText-Medium">
                    Start visualizing
                </span>
            </button>
        </div>
    );
};

export default NoPastCreationFound;